export const types = {
    SET_GET_BRANDS: '[BRANDS] SET GET BRANDS',
    SET_GET_BRANDS_BY_ID: '[BRANDS] SET GET BRANDS BY ID'
}